import { Property } from "csstype";
import React from "react";

const Divider: React.FC<{ color?: Property.BackgroundColor }> = ({
  color = "var(--tlx-stroke-border-default)",
}) => {
  return (
    <hr
      className="tlx-divider"
      style={{
        border: "none",
        height: "1px",
        margin: "var(--tlx-space-2) 0",
        flexShrink: "0",
        backgroundColor: color,
      }}
    />
  );
};

export default Divider;
